import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createPresetFailed, createPresetSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createPreset(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-preset`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === CREATED) {
      yield put(createPresetSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield dataResponse.json();
      yield put(createPresetFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createPresetFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
